import { PredefinedDataRow } from 'components/tables/data/predefined/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the predefined data type.
 */
export default function PredefinedDataTypeColumn({ data: { predefinedDataType } }: { data: PredefinedDataRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {predefinedDataType.name}
    </P2Regular>
  );
}
